import { CardString, StandardHandTypeWithRoyalFlush } from 'pokersolver'
import React from 'react'
import { StyleSheet, Text, View } from 'react-native'

import { fontFamily } from '../../theme'
import { Card } from '../TempNewDesign/Card'
import { Dimensions } from 'react-native'

type RankingCard = {
  ranking: StandardHandTypeWithRoyalFlush
  cards: CardString[]
  numberOfCardDisabled: number
}

const royalFlush: RankingCard = {
  ranking: 'Royal Flush',
  cards: ['Ah', 'Kh', 'Qh', 'Jh', 'Th'],
  numberOfCardDisabled: 0
}
const straightFlush: RankingCard = {
  ranking: 'Straight Flush',
  cards: ['Js', 'Ts', '9s', '8s', '7s'],
  numberOfCardDisabled: 0
}
const fourOfAKind: RankingCard = {
  ranking: 'Four of a Kind',
  cards: ['9h', '9s', '9d', '9c', '8d'],
  numberOfCardDisabled: 1
}
const fullHouse: RankingCard = { ranking: 'Full House', cards: ['Qh', 'Qc', 'Qd', '8h', '8s'], numberOfCardDisabled: 0 }
const flush: RankingCard = { ranking: 'Flush', cards: ['Kc', 'Jc', '8c', '6c', '2c'], numberOfCardDisabled: 0 }
const straight: RankingCard = { ranking: 'Straight', cards: ['Qh', 'Jc', 'Td', '9s', '8h'], numberOfCardDisabled: 0 }
const threeOfAKind: RankingCard = {
  ranking: 'Three of a Kind',
  cards: ['Js', 'Jc', 'Jh', '8s', 'Tc'],
  numberOfCardDisabled: 2
}
const twoPair: RankingCard = { ranking: 'Two Pair', cards: ['Kc', 'Kh', '9s', '9d', 'Th'], numberOfCardDisabled: 1 }
const pair: RankingCard = { ranking: 'Pair', cards: ['7h', '7s', '6s', '8s', 'Th'], numberOfCardDisabled: 3 }
const highCard: RankingCard = { ranking: 'High Card', cards: ['As', 'Kh', '6s', '8s', 'Th'], numberOfCardDisabled: 4 }

const rankingCards: RankingCard[] = [
  royalFlush,
  straightFlush,
  fourOfAKind,
  fullHouse,
  flush,
  straight,
  threeOfAKind,
  twoPair,
  pair,
  highCard
]

const RankingCards = () => {
  const windowWidth = Dimensions.get('window').width

  return (
    <View style={styles.container}>
      {rankingCards.map(({ ranking, cards, numberOfCardDisabled }, idx) => (
        <View key={`hand-${idx}`} style={styles.rankingCardContainer}>
          <View style={styles.rankingTextContainer}>
            <Text style={[styles.text, { fontSize: windowWidth < 380 ? 16 : 20 }]}>{ranking}</Text>
          </View>
          <View style={styles.cardsContainer}>
            {cards.map((c, idx2) => (
              <Card
                key={`card-${idx}-${idx2}`}
                card={c}
                cardTextStyle={{ fontFamily: fontFamily.FeatureDeckRegular }}
                disabled={!(idx2 < cards.length - numberOfCardDisabled)}
                fontSize={windowWidth < 375 ? 14 : 16}
              />
            ))}
          </View>
        </View>
      ))}
    </View>
  )
}

export default RankingCards

const styles = StyleSheet.create({
  container: {
    marginTop: 16
  },
  rankingTextContainer: {
    justifyContent: 'flex-end'
  },
  text: {
    fontFamily: fontFamily.FeatureDeckRegular
  },
  rankingCardContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 16,
    borderBottomWidth: 1
  },
  cardsContainer: {
    flexDirection: 'row',
    gap: 5
  }
})
